import { render, staticRenderFns } from "./BottomBtnGroup.vue?vue&type=template&id=ff5d8bb8&scoped=true&"
import script from "./BottomBtnGroup.vue?vue&type=script&lang=js&"
export * from "./BottomBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./BottomBtnGroup.vue?vue&type=style&index=0&id=ff5d8bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5d8bb8",
  null
  
)

export default component.exports